'use client';

import { useEffect, useState } from 'react';

export type CountdownProps = {
  initialSeconds: number;
  isActive?: boolean;
  onEnd?: () => void;
};

export function Countdown({
  initialSeconds,
  isActive = true,
  onEnd,
}: CountdownProps) {
  const [count, setCount] = useState(initialSeconds);

  useEffect(() => {
    setCount(initialSeconds);
  }, [initialSeconds]);

  useEffect(() => {
    if (!isActive) {
      return;
    }

    if (count <= 0) {
      onEnd?.();
      return;
    }

    const timeout = setTimeout(() => {
      setCount((current) => current - 1);
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, [isActive, count, onEnd]);

  return count;
}
